import React, { useEffect, useRef, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Sidebar from './Sidebar';
import StarterDetail from './StarterDetail';
import PasteSandbox from './PasteSandbox';
import { VarValuesProvider } from './varValuesContext';

function ExplorerHome() {
  return (
    <div style={{ padding: '2rem', maxWidth: 720 }}>
      <h1>Components Explorer</h1>
      <p style={{ fontSize: 16, lineHeight: 1.6, color: '#4a5568' }}>
        Browse all 25 starters across the 5 React component slots. Each starter renders live
        with inline FAKE_DATA — so you can SEE what a component looks like before pasting it
        into your challenge admin form.
      </p>
      <p style={{ fontSize: 16, lineHeight: 1.6, color: '#4a5568' }}>
        Pick a slot from the sidebar to start, or use the <strong>Paste your own code</strong> sandbox
        to verify component code (including LLM output) before saving it to a real challenge.
      </p>
      <p style={{ fontSize: 13, color: '#718096', marginTop: '2rem' }}>
        Documentation: <a href="https://github.com/AIcrowd/aicrowd/tree/master/docs/components" target="_blank" rel="noreferrer">docs/components/</a>
      </p>
    </div>
  );
}

export default function ComponentsExplorer() {
  // Fill the viewport *below* whatever sits above us (the global header), instead
  // of a flat 100vh that overflows the screen and makes the whole page scroll.
  const rootRef = useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState('100vh');
  useEffect(() => {
    const update = () => {
      const el = rootRef.current;
      if (!el) return;
      const top = el.getBoundingClientRect().top + window.scrollY;
      setHeight(`calc(100vh - ${Math.max(0, Math.round(top))}px)`);
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  return (
    <BrowserRouter>
      <VarValuesProvider>
        <div ref={rootRef} style={{ display: 'flex', height }}>
          <Sidebar />
          <main style={{ flex: 1, overflow: 'hidden', minWidth: 0 }}>
            <Routes>
              <Route path="/admin/components/explorer" element={<ExplorerHome />} />
              <Route path="/admin/components/explorer/sandbox" element={<PasteSandbox />} />
              <Route path="/admin/components/explorer/:slot/:pattern" element={<StarterDetail />} />
            </Routes>
          </main>
        </div>
      </VarValuesProvider>
    </BrowserRouter>
  );
}
